import React, { useRef } from 'react';
import UploadContainer from '../../components/UploadContainer';
import { APP_ROUTES } from '../../constants/appRoutes';

const UploadPhotoWithCode = () => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  return (
    <UploadContainer
      title="Upload an image"
      text="Drag and drop the image here"
      buttonText="Upload"
      buttonAction={() => fileInputRef.current?.click()}
      fileInputRef={fileInputRef}
      withFileInp={true}
      navigateNextLink={APP_ROUTES.EDITOR}
    />
  );
};

export default UploadPhotoWithCode;
